/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CorporateProgram } from './';
import {
    CorporateProgramFromJSON,
    CorporateProgramFromJSONTyped,
    CorporateProgramToJSON,
} from './';
import type { FreelancerVertical } from './';
import {
    FreelancerVerticalFromJSON,
    FreelancerVerticalFromJSONTyped,
    FreelancerVerticalToJSON,
} from './';
import type { FreelancingExperience } from './';
import {
    FreelancingExperienceFromJSON,
    FreelancingExperienceFromJSONTyped,
    FreelancingExperienceToJSON,
} from './';

/**
 * 
 * @export
 * @interface InitWorkflowRequest
 */
export interface InitWorkflowRequest {
    /**
     * 
     * @type {FreelancerVertical}
     * @memberof InitWorkflowRequest
     */
    freelancerVertical: FreelancerVertical;
    /**
     * 
     * @type {string}
     * @memberof InitWorkflowRequest
     */
    repatriationTokenId?: string;
    /**
     * 
     * @type {CorporateProgram}
     * @memberof InitWorkflowRequest
     */
    corporateProgram?: CorporateProgram;
    /**
     * 
     * @type {string}
     * @memberof InitWorkflowRequest
     */
    invitationCode?: string;
    /**
     * 
     * @type {FreelancingExperience}
     * @memberof InitWorkflowRequest
     */
    freelancingExperience?: FreelancingExperience;
}

/**
 * Check if a given object implements the InitWorkflowRequest interface.
 */
export function instanceOfInitWorkflowRequest(value: object): value is InitWorkflowRequest {
    if (!('freelancerVertical' in value) || value['freelancerVertical'] === undefined) return false;
    return true;
}

export function InitWorkflowRequestFromJSON(json: any): InitWorkflowRequest {
    return InitWorkflowRequestFromJSONTyped(json, false);
}

export function InitWorkflowRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitWorkflowRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'freelancerVertical': FreelancerVerticalFromJSON(json['freelancerVertical']),
        'repatriationTokenId': json['repatriationTokenId'] == null ? undefined : json['repatriationTokenId'],
        'corporateProgram': json['corporateProgram'] == null ? undefined : CorporateProgramFromJSON(json['corporateProgram']),
        'invitationCode': json['invitationCode'] == null ? undefined : json['invitationCode'],
        'freelancingExperience': json['freelancingExperience'] == null ? undefined : FreelancingExperienceFromJSON(json['freelancingExperience']),
    };
}

export function InitWorkflowRequestToJSON(value?: InitWorkflowRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'freelancerVertical': FreelancerVerticalToJSON(value['freelancerVertical']),
        'repatriationTokenId': value['repatriationTokenId'],
        'corporateProgram': CorporateProgramToJSON(value['corporateProgram']),
        'invitationCode': value['invitationCode'],
        'freelancingExperience': FreelancingExperienceToJSON(value['freelancingExperience']),
    };
}

